import { useState } from 'react';
import { Badge, Card, CardContent, CardHeader, CardTitle, Input } from '@mlm/ui';
import { PageHeader } from './_shared';
import {
  ACCOUNT_TYPE_LABEL,
  ACCOUNTS,
  AS_OF_LABEL,
  type AccountType,
  peso,
} from './sample-data';

const TYPE_ORDER: AccountType[] = ['asset', 'liability', 'equity', 'income', 'expense'];

export function ChartOfAccountsPage() {
  const [q, setQ] = useState('');
  const needle = q.trim().toLowerCase();
  const rows = needle
    ? ACCOUNTS.filter(
        (a) => a.code.includes(needle) || a.name.toLowerCase().includes(needle),
      )
    : ACCOUNTS;

  return (
    <div className="space-y-4">
      <PageHeader
        title="Chart of Accounts"
        subtitle={`${ACCOUNTS.length} accounts · balances as of ${AS_OF_LABEL}`}
      />

      <Card>
        <CardHeader>
          <CardTitle>Filters</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-1 gap-3 md:grid-cols-3">
          <div className="space-y-1">
            <label className="text-xs text-muted-foreground" htmlFor="coa-search">
              Search
            </label>
            <Input
              id="coa-search"
              className="h-9"
              placeholder="Account code or name"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
        </CardContent>
      </Card>

      {TYPE_ORDER.map((type) => {
        const group = rows.filter((a) => a.type === type);
        if (group.length === 0) return null;
        return (
          <Card key={type}>
            <CardHeader>
              <CardTitle>
                {ACCOUNT_TYPE_LABEL[type]}{' '}
                <span className="text-sm font-normal text-muted-foreground">
                  ({group.length})
                </span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <table className="w-full text-sm">
                <thead className="border-b text-left text-xs text-muted-foreground">
                  <tr>
                    <th className="w-24 px-4 py-2">Code</th>
                    <th className="px-4 py-2">Account</th>
                    <th className="w-28 px-4 py-2">Status</th>
                    <th className="w-44 px-4 py-2 text-right">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {group.map((a) => (
                    <tr key={a.code} className="border-b last:border-0 hover:bg-muted/30">
                      <td className="px-4 py-2 font-mono text-xs">{a.code}</td>
                      <td className="px-4 py-2">
                        <div>{a.name}</div>
                        {a.note ? (
                          <div className="text-xs text-muted-foreground">{a.note}</div>
                        ) : null}
                      </td>
                      <td className="px-4 py-2">
                        <Badge variant={a.active ? 'success' : 'muted'}>
                          {a.active ? 'Active' : 'Inactive'}
                        </Badge>
                      </td>
                      <td className="px-4 py-2 text-right font-mono tabular-nums">
                        {peso(a.balance)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
